import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { icons } from '../../../../../configs/Icons';
import { ButtonPest } from '../../../../utils/Button';
import { CamelCaseToHyphen } from '../../../../utils/TextFormatter';
import { GetSearchParams, mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';

function TabButton({ title, name, active, onClick }) {
    return (
        <button
            type="button"
            onClick={() => onClick(CamelCaseToHyphen(name?.toLowerCase()))}
            className={cn(
                `group h-full w-full md:w-auto md:min-w-20 flex justify-center items-center gap-2.5 bg-transparent text-secondary hover:bg-secondary hover:text-white font-medium text-base focus:outline-none outline-none transition-colors cursor-pointer rounded-md px-3 py-2`,
                {
                    'active bg-secondary text-white': active
                }
            )}
        >
            <span className="inline-block capitalize whitespace-nowrap">{title || name}</span>
        </button>
    );
}

function CustomerTableTab({ openModal, data }) {
    const navigate = useNavigate();
    const { id, addresses, agencyId } = data;
    const [activeTab, setActiveTab] = useState(GetSearchParams('tab') || 'subscriptions');
    const handleSetTab = (tab) => {
        setActiveTab(tab);
        navigate(
            mkRelativeUrl(`/agency/${agencyId}/customers/${id}/info`, {
                tab
            })
        );
    };
    return (
        <div className="flex justify-start items-center gap-2 title text-xl font-medium text-primary mb-4 ml-[1px]">
            <div className="flex flex-wrap flex-row gap-2 flex-1 items-center justify-between overflow-hidden">
                <span
                    className={cn(
                        'h-13 p-[5px] flex sm:inline-flex flex-nowrap justify-start items-center gap-[5px] bg-secondary-100 rounded-10 overflow-auto md:overflow-hidden custom-scrollbar scroll-h-sm',
                        {
                            'placeholder-mode': data?.demo
                        }
                    )}
                >
                    {/* <TabButton
                        name="customers"
                        onClick={handleSetTab}
                        active={activeTab === 'customers'}
                    /> */}
                    <TabButton
                        name="subscriptions"
                        onClick={handleSetTab}
                        active={activeTab === 'subscriptions'}
                    />
                    <TabButton
                        name="services"
                        title="Services"
                        onClick={handleSetTab}
                        active={activeTab === 'services'}
                        total={data?.payments?.length}
                    />
                    <TabButton
                        name="invoices"
                        onClick={handleSetTab}
                        active={activeTab === 'invoices'}
                    />
                    <TabButton
                        name="payments"
                        onClick={handleSetTab}
                        active={activeTab === 'payments'}
                    />

                    <TabButton
                        title="Support Ticket's"
                        name="support-ticket"
                        onClick={handleSetTab}
                        active={activeTab === 'support-ticket'}
                    />

                    {/* <TabButton
                        title="Permissions"
                        name="permissions"
                        onClick={handleSetTab}
                        active={activeTab === 'permissions'}
                    /> */}
                </span>

                <div className="flex flex-col sm:flex-row gap-3">
                    {data?.role === 'customer' ? (
                        <>
                            <ButtonPest
                                onClick={() => openModal('new-subscription')}
                                className="w-50 h-10 md:h-13 text-base flex justify-center items-center gap-2"
                                disabled={
                                    data?.dem ||
                                    data?.status === 'inactive' ||
                                    addresses.billing === null ||
                                    !data?.isActiveAgency
                                }
                                toolTipTitle={
                                    addresses.billing === null ? 'Add Billing Address' : null
                                }
                            >
                                <img src={icons.plusW} alt="Plus" />
                                <span> Order New Subscription</span>
                            </ButtonPest>
                            <ButtonPest
                                onClick={() => openModal('new-service')}
                                className="w-44 h-10 md:h-13 text-base flex justify-center items-center gap-2"
                                disabled={
                                    data?.dem ||
                                    data?.status === 'inactive' ||
                                    addresses.billing === null ||
                                    !data?.isActiveAgency
                                }
                                toolTipTitle={
                                    addresses.billing === null ? 'Add Billing Address' : null
                                }
                            >
                                <img src={icons.plusW} alt="Plus" />
                                <span> Order New Service</span>
                            </ButtonPest>
                        </>
                    ) : null}
                </div>
            </div>
        </div>
    );
}

export default CustomerTableTab;
